import Button from "@/components/Button/Button"
import { rem } from "@/styles/utils"
import { yellow } from "@/styles/variable"
import * as Dialog from "@radix-ui/react-dialog"
import styled from "styled-components"

export const StyledDialog = {
  Overlay: styled(Dialog.Overlay)`
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    inset: 0;
  `,
  Content: styled(Dialog.Content)`
    position: fixed;
    z-index: 10;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    background-color: #26282c;
    border-radius: 10px;
    color: #fff;
    max-width: min(${rem(400)}, calc(100% - ${rem(60)}));
    width: 100%;
    animation: dialogShow 200ms ease-out forwards;

    @keyframes dialogShow {
      0% {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.95);
      }
      100% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
      }
    }
  `,
  ContentBox: styled.div`
    text-align: left;
    width: 100%;
    padding: 30px 30px 0px;
  `,
  ButtonBox: styled.div`
    display: flex;
    align-items: center;
    gap: ${rem(6)};
    margin: ${rem(24)} 0;
    padding-left: 30px;
    padding-right: 30px;
    > * {
      flex: 1;
    }

    @media (max-width: 320px) {
      padding-left: 5vw;
      padding-right: 5vw;
    }
  `,
  CancelButton: styled(Button)`
    background-color: #4a4f56;
    border-color: #4a4f56;
  `,
  ConfirmButton: styled(Button)`
    border-color: ${yellow.FDD};
  `
}
